import type React from 'react';
import { createContext, useContext } from 'react';
import { isAuthenticatedRamConfig } from '../../env/runtime-config';
import type { IAuthenticatedRamConfig, IRamRuntimeConfig } from '../../env/types';

export interface ConfigContextValue {
    config: IRamRuntimeConfig | null;
    loading: boolean;
    isLoadingAuthenticatedConfig: boolean;
    error: string | null;
    loadPublicConfig: () => Promise<void>;
    loadAuthenticatedConfig: () => Promise<void>;
}

export const ConfigContext = createContext<ConfigContextValue | null>(null);

export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (context == null) {
        throw new Error('useConfig must be used within a ConfigProvider');
    }
    return context;
};

export const useTargetEnv = (...envs: string[]) => {
    const config = useConfig();

    return envs.includes(config.config.ENVIRONMENT_NAME);
};

export const useAuthenticatedConfig = (): IAuthenticatedRamConfig => {
    const { config } = useConfig();
    if (!isAuthenticatedRamConfig(config)) {
        throw new Error('useAuthenticatedConfig must be used after authenticated config is loaded');
    }

    return config;
};
